// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/pages.scss";
// import "./components/slider";
import "./components/readmore";

// Bloc calendar
import './plugins/bloc-calendar';
